const { isEmpty } = require('lodash');

const required = (value) => {
  let val = value;

  if (Number.isInteger(value)) {
    val = value.toString();
  }
  
  return !isEmpty(val);
};

const length = (value, min = null, max = null) => {
  if (value) {
          return (min ? value.length > min : true) && (max ? value.length < max : true);
      } else {
    return true;
  }
};

const onlyLatinAphaNumericNoSpaces = (value, acceptEmpty = false) => {
  if (isEmpty(value)) {
    return acceptEmpty;
  } else {
    const regex = /^[a-z\d\-_]+$/i;
    const isValid = regex.test(value);

    return isValid;
  }
};

/**
 * Verifies that a single-line value is a valid email
 * Returns bool true if valid; false otherwise
 * @param {string} value the string to verify against
 * @param {boolean} isUnicode true if use of unicode characters is permitted; false otherwise
 * Implemented as to allow characters based on RFC5322 Section 3.4 standards and http://rumkin.com/software/email/rfc.php
 * 
  a-zA-Z0-9!#$%&'*+-/=?^_`{|}~
  . (not first or last character, doesn't appear consecutively)
  @
  domain names can only contain letters, numbers, and dashes
  *
  * Only ASCII support:
  *
  (?=[A-Z0-9@\.!#$%&'*+/=?^_`{|}~\-]{5,253}$) enforce the 254 character limit ahead; pre-check for invalid characters overall;
  ([A-Z0-9!#$%&'*+/=?^_`{|}~\-]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~\-]+)*){1,64} start with a letter or a digit; any dot must be followed by a character; max 64 characters back
  @ 
  (?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8} // no consecutive dashes or dots; max 8 sub-domains; total of 63 characters ahead;
  [A-Z]{2,63}$ // end with letters only; max 63 characters back
  *
  * Added Unicode character support at places marked with HERE: 
  * 
  /^(?=[A-Z0-9@\.!#$%&'*+/=?^_`{|}~\-HERE]{5,253}$)
  ([A-Z0-9!#$%&'*+/=?^_`{|}~\-HERE]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~\-HERE]+)*){1,64}
  @
  (?:(?=[A-Z0-9-HERE]{1,63}\.)[A-Z0-9HERE]+(?:-[A-Z0-9HERE]+)*\.){1,8}
  [A-ZHERE]{2,63}$/ui
  *
  * HERE <=> \u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}
*/
const isEmailValid = (value, isUnicode = false) => {
  let regex = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/i;
  // if (isUnicode) {
  //   regex = /^(?=[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{0040}\u{002D}-\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{5,253}$)([\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+(?:[\u{002E}][\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{002F}\u{0021}\u{0023}-\u{0027}\u{002A}\u{002B}\u{003D}\u{003F}\u{005E}-\u{0060}\u{007B}-\u{007E}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+)*){1,64}@(?:(?=[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{002D}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{1,63}\u{002E})[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+(?:\u{002D}[\u{0041}-\u{005A}\u{0030}-\u{0039}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]+)*\u{002E}){1,8}[\u{0041}-\u{005A}\u{00C0}-\u{00D6}\u{00D9}-\u{00DD}\u{0100}-\u{017E}\u{0410}-\u{042F}\u{048A}-\u{0529}]{2,63}$/iu;
  // } else {
  //   regex = /^(?=[A-Z0-9@.!#$%&'*+/=?^_`{|}~-]{5,253}$)([A-Z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[A-Z0-9!#$%&'*+/=?^_`{|}~-]+)*){1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/i
  // }

  const isValid = regex.test(value);
  return isValid;
};

const isSourceValid = (source) => {
  return required(source) && length(source, 1, 21) && onlyLatinAphaNumericNoSpaces(source);
};  

const isValidFileName = (fileName) => {
  return /^[a-z0-9_.@()-\s]+$/gi.test(fileName);
};

const isStrongPassword = (password) => {
  const pattern = /^(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.{8,})/;  
  return password.search(pattern) > -1 ? true : false;
};

module.exports = { 
  isSourceValid, 
  required, 
  length, 
  onlyLatinAphaNumericNoSpaces, 
  isValidFileName, 
  isStrongPassword, 
  isEmailValid
};